// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageControl_root__qsq_t","controlTrigger":"MessageControl_controlTrigger__3ZHUu","tooltipContent":"MessageControl_tooltipContent__1Lz0e"};